import React, { useMemo } from "react";
import { Box } from "@mui/material";
import RespondentIntlProvider from "../../../components/RespondentIntlProvider";
import VoiceSurveyRunner from "./VoiceSurveyRunner";

// The builder's steps in the runner's shape (RespondSurveyPage's adapted
// /questions shape). Unsaved choices have no id yet, so an option is keyed by its
// value (or text), as the classic preview keys it; `isMandatory` is the builder's
// name for is_required.
export const previewSteps = (steps) =>
    (steps || []).map((step) => ({
        id: step.id,
        type: String(step.type || "").toUpperCase(),
        question: step.question || "",
        description: step.description || "",
        is_required: !!(step.is_required || step.isMandatory),
        choices: [...(step.choices || [])]
            .sort((a, b) => (a.index || 0) - (b.index || 0))
            .map((c) => ({ id: c.id ?? c.value ?? c.text, text: c.text })),
    }));

// The Preview tab of a Modern (voice-mode) assessment: the respondent runner
// itself over the unsaved steps, in the survey's language, voice and look.
// Nothing is saved, and Submit does nothing.
export default function VoiceSurveyPreview({ steps, settings, title }) {
    const runnerSteps = useMemo(() => previewSteps(steps), [steps]);
    const survey = useMemo(
        () => ({
            title: settings?.title || title || "",
            description: settings?.description || "",
            language: settings?.language || "en",
            voice: settings?.voice,
            settings: settings || {}, // the appearance and confirmation-page settings
        }),
        [settings, title]
    );
    return (
        // At least the preview pane's height, so the survey's background fills it;
        // taller only when the screen in it is.
        <Box data-testid="voice-survey-preview" sx={{ minHeight: "100%", display: "flex", flexDirection: "column", borderRadius: 2, overflow: "hidden" }}>
            <RespondentIntlProvider>
                <VoiceSurveyRunner survey={survey} steps={runnerSteps} preview />
            </RespondentIntlProvider>
        </Box>
    );
}
